<template>
  <transition name="loading">
    <div
      v-if="loading && mode !== 'latest'"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen bg-black bg-opacity-40"
    >
      <div class="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["mode", "loading"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style>
.loading-enter-active,
.loading-leave-active {
  @apply transition duration-300;
}

.loading-enter,
.loading-leave-to {
  @apply opacity-0;
}

.lds-ring {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  position: absolute;
  box-sizing: border-box;
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 3px solid #fff;
  border-color: #fff transparent transparent transparent;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
